/**
 * Ultra-Minimal Badge Component
 * Thin borders, flat colors, minimal padding
 */

interface BadgeProps {
  children: React.ReactNode;
  variant?: 'success' | 'error' | 'warning' | 'info' | 'default';
  className?: string;
}

export function Badge({ children, variant = 'default', className = '' }: BadgeProps) {
  const variantClasses = {
    success: 'text-green-700 border-green-300 bg-green-50',
    error: 'text-red-700 border-red-300 bg-red-50',
    warning: 'text-amber-700 border-amber-300 bg-amber-50',
    info: 'text-blue-700 border-blue-300 bg-blue-50',
    default: 'text-gray-700 border-gray-300 bg-gray-50',
  };
  
  return (
    <span className={`inline-flex items-center px-2 py-0.5 text-xs font-medium border rounded ${variantClasses[variant]} ${className}`}>
      {children}
    </span>
  );
}
